import { baseApi } from "./baseApi";

// the member's choice about feature emails (backend /api/mail/feature-emails).
// sign-in codes and account emails don't depend on it.

export interface FeatureEmailsState {
  subscribed: boolean;
}

interface FeatureEmailsResponse {
  success: boolean;
  data?: FeatureEmailsState;
  error?: string;
}

export const featureEmailsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureEmails: builder.query<FeatureEmailsState | undefined, void>({
      query: () => "/mail/feature-emails",
      transformResponse: (response: FeatureEmailsResponse) => response.data,
    }),
    setFeatureEmails: builder.mutation<FeatureEmailsState | undefined, FeatureEmailsState>({
      query: (body) => ({
        url: "/mail/feature-emails",
        method: "PUT",
        body,
      }),
      transformResponse: (response: FeatureEmailsResponse) => response.data,
      // flip the switch right away, put it back if the PUT fails
      async onQueryStarted({ subscribed }, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          featureEmailsApi.util.updateQueryData("getFeatureEmails", undefined, () => ({ subscribed }))
        );
        try {
          const { data } = await queryFulfilled;
          if (data && typeof data.subscribed === "boolean") {
            // the server's answer wins over the optimistic value
            dispatch(
              featureEmailsApi.util.updateQueryData("getFeatureEmails", undefined, () => ({
                subscribed: data.subscribed,
              }))
            );
          }
        } catch {
          patch.undo();
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetFeatureEmailsQuery, useSetFeatureEmailsMutation } = featureEmailsApi;
